import {
  getSelectedDistrict,
  getSelectedLeague,
  getSelectedSport,
  getSelectedState,
} from 'app/imports/App.selectors'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function LayoutHeaderState() {
  const selectedState = useSelector(getSelectedState)
  const selectedSport = useSelector(getSelectedSport)
  const selectedDistrict = useSelector(getSelectedDistrict)
  const selectedLeague = useSelector(getSelectedLeague)

  const title = useMemo(() => {
    if (!selectedState || selectedState.length === 0) return ''

    if (selectedState.length > 1) return ''

    const state = selectedState[0]
    let result = ''

    if (selectedDistrict && selectedDistrict.length > 0) {
      if (selectedDistrict.length > 1) {
        return ''
      }
      result += `${selectedDistrict[0].name}`
    } else if (selectedLeague && selectedLeague.length > 0) {
      if (selectedLeague.length > 1) {
        return ''
      }
      result += `${selectedLeague[0].name}`
    } else {
      result += state.name
    }

    if (selectedSport && selectedSport.length > 0) {
      if (selectedSport.length === 1) {
        result += ` ${selectedSport[0].name}`
      }
    }

    return result
  }, [selectedState, selectedDistrict, selectedLeague, selectedSport])

  if (!selectedState || selectedState.length === 0) {
    return null
  }

  return (
    <>
      <title>{`Scoreboard | ${title}`}</title>
      {title}
    </>
  )
}
